import { render, staticRenderFns } from "./TuketiciHakemHeyetiKarariAlacakFormWizard.vue?vue&type=template&id=2f19a200"
import script from "./TuketiciHakemHeyetiKarariAlacakFormWizard.vue?vue&type=script&lang=ts"
export * from "./TuketiciHakemHeyetiKarariAlacakFormWizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports